import React from "react";
import { IonPage, IonSplitPane } from "@ionic/react";
import InternalRoutes from "../routes/internal";

import { connect } from "react-redux";
import AppMenu from "../components/Menu/AppMenu";
import { requireAuth } from "../components/auth";

interface Props {
	loggedIn: any;
}

const InternalLayout: React.FC<Props> = ({ loggedIn }) => {
	if (loggedIn === true) {
		return (
			<IonSplitPane id="split-pane" contentId="main-content" when="lg">
				<AppMenu />
				<IonPage id="main-content">
					<InternalRoutes />
				</IonPage>
			</IonSplitPane>
		);
	} else return null;
};

const mapStateToProps = (state: any) => ({
	loggedIn: state.user.loggedIn,
});

export default connect(mapStateToProps, {})(requireAuth(InternalLayout));
